import { IEntityReponse } from "../model/base/response/entity-response";

// Ambiente definido pelo host do portal (mesma regra do http-client): "-sand" na URL aponta para o sandbox
export const isSandbox = (): boolean => window.location.hostname.includes('-sand');

const PORTAL_DOMAIN = 'airdoc.com.br';
export const isLocalhost = (): boolean => ['localhost', '127.0.0.1'].includes(window.location.hostname);
const suffix = () => (isSandbox() ? '-sand' : '');

/** Área Administrativa (APM) do ambiente atual. */
export const adminUrl = (): string => `https://apm${suffix()}.${PORTAL_DOMAIN}`;

/** SCP do ambiente atual. */
export const scpUrl = (): string => `https://scp${suffix()}.${PORTAL_DOMAIN}`;

/** GED (Documentos Eletrônicos) do ambiente atual; é de uso interno, sem área pública por entidade. */
export const gedUrl = (): string => `https://ged${suffix()}.${PORTAL_DOMAIN}`;

/**
 * Caminho da entidade nas áreas públicas dos sistemas: "/ba/pmitabuna" (pm = prefeitura, cm = câmara),
 * mesma regra do buildPublicPortalPath do applications.
 */
const entityPublicPath = (entity?: IEntityReponse): string | undefined => {
  const uf = entity?.address?.stateCode;
  const city = entity?.address?.city;
  if (!uf || !city) return undefined;
  const prefix = entity?.entityType === 2 ? 'cm' : 'pm';
  const citySlug = city.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  return `/${uf.toLowerCase()}/${prefix}${citySlug}`;
};

// Área pública do sistema para a entidade; sem estado/cidade cadastrados cai na raiz do sistema
const publicAreaUrl = (system: string, section: string, entity?: IEntityReponse): string => {
  const base = `https://${system}${suffix()}.${PORTAL_DOMAIN}`;
  const path = entityPublicPath(entity);
  return path ? `${base}${path}/${section}` : base;
};

// SIC e Ouvidoria novos ainda não foram liberados: fora do localhost os links levam aos sistemas antigos
const legacyUrl = (path: string, entity?: IEntityReponse): string =>
  `https://${PORTAL_DOMAIN}/${path}?codEntidade=${entity?.document || ''}&empresa=3851`;

/** Área pública da Ouvidoria (OUV) da entidade no ambiente atual. */
export const ouvUrl = (entity?: IEntityReponse): string =>
  isLocalhost() ? publicAreaUrl('ouv', 'ouvidoria', entity) : legacyUrl('ouvidoria', entity);

/** Área pública do Serviço de Informação ao Cidadão (SIC) da entidade no ambiente atual. */
export const sicUrl = (entity?: IEntityReponse): string =>
  isLocalhost() ? publicAreaUrl('sic', 'sic', entity) : legacyUrl('sic', entity);

/** SER (Sistema de Envio de Remessas) do ambiente atual. */
export const serUrl = (): string => `https://ser${suffix()}.${PORTAL_DOMAIN}`;
